import states from "./states"
import {
  MODIFY_CAMPAIGNS_STATE,
  UPDATE_CAMPAIGNS_STATE,
  DELETE_CAMPAIGNS_RECORD,
  UPDATE_CAMPAIGN_DETAILS_STATE,
  UPDATE_CAMPAIGN_STATUS,
  UPDATE_CAMPAIGNS,
} from "./actiontypes"

const campaigns_details = (state = states.campaigns_details, action) => {
  switch (action.type) {
    case UPDATE_CAMPAIGNS_STATE:
      return {
        ...state,
        ...action.payload,
      }

    case MODIFY_CAMPAIGNS_STATE:
      return {
        ...state,
        campaigns: state.campaigns.map(c =>
          c.campaignId === action.payload.campaignId ? action.payload : c
        ),
      }

    case DELETE_CAMPAIGNS_RECORD:
      return {
        ...state,
        campaigns: state.campaigns.filter(
          c => c.campaignId !== action.payload.cid
        ),
      }

    // below are campaigns details

    case UPDATE_CAMPAIGN_DETAILS_STATE:
      return {
        ...state,
        records: [...state.records, ...action.payload.records],
      }

    case UPDATE_CAMPAIGN_STATUS: {
      const pollingIds = state.pollingIds || []

      const updates = Array.isArray(action.payload)
        ? action.payload
        : [action.payload]

      let newPollingIds = [...pollingIds]

      updates.forEach(item => {
        if (item?.status === "creating") {
          if (!newPollingIds.includes(item._id)) {
            newPollingIds.push(item._id)
          }
        } else {
          newPollingIds = newPollingIds.filter(id => id !== item._id)
        }
      })

      return {
        ...state,
        pollingIds: newPollingIds,
      }
    }

    case UPDATE_CAMPAIGNS:
      const updatedCampaigns = action.payload

      return {
        ...state,
        campaigns: state.campaigns.map(existingCampaign => {
          const updatedCampaign = updatedCampaigns.find(
            campaign => campaign._id === existingCampaign._id
          )
          return updatedCampaign ? updatedCampaign : existingCampaign
        }),
      }

    default:
      return state
  }
}

export default campaigns_details
